export default "__VITE_ASSET__CAh217uP__"